import { currencyData } from "../utils/constants";
import { getFromLocalStorage } from "../utils/localStorageUtils";
import ProductCard from "./common/ProductCard";

const HomeProductSlider = ({ products }) => {
    let currency = getFromLocalStorage(currencyData);

    return (
        <>
            {products?.map((product, index) => {
                let img = product.itemObj?.media;
                const productImage = img?.length > 0 ? img[0].original_url : 'assets/img/furnite/1.png';

                // Merge derived image into product for the card component
                const productWithImage = { ...product, image: productImage };

                return (
                    <div key={`product-${index}`} className="col-xl-3 col-lg-4 col-md-6 col-6">
                        <ProductCard product={productWithImage} currency={currency} />
                    </div>
                );
            })}
        </>
    );
};

export default HomeProductSlider;
